import { render } from "./Panel.vue?vue&type=template&id=df6a15b0&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=df6a15b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6a15b0"]])

export default __exports__